import { Fragment, useEffect, useState, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
    getProductTikToks,
    getCheckProductTikTok,
    deleteProductTikTok,
    deleteProductTikTok2,
    editProductTikTok,
    changeStatusProductTikTok,
    syncProductTikTokById,
    syncListPrice,
} from "actions/productTikTokActions";
import { createProductById } from "actions/productActions";
import { getStaffs } from "actions/teamActions";
import { ReactTable, ReactTableDataGrid } from "components/Table";
import { ListDateType } from "helper/constant";
import { formatterCreateAt, convertTZ, FormatterStatus, sleep, findMinQuantity } from "components/Function";
import SelectBox from "components/elements/selectBox";
import Loading from "components/Loading";
import EditProductTikTok from "./EditProductTikTok";
import ModalDeleteProductTikTok from "./modalDeleteProductTikTok";
import _ from "lodash";
import Swal from "sweetalert2";
import { CSVLink } from "react-csv";
import { ModalSchedule, ModalAnalytic } from "./modal";
import ModalScheduleMulti from "./modalScheduleMulti";
import ReactImageMagnify from "react-image-magnify";
import { productScheduleMulti } from "actions/productScheduleActions";
import { getShops } from "actions/shopActions";
import CustomHeader from "components/elements/customHeaderTable";
import ModalEditPrice from "./editProductPrice";
import ModalEditQty from "./editProductQty";
import ModalEditProductV2 from "./editProductV2";
import ModalListPrice from "../modalListPrice";

const ProductList = ({
    getProductTikToks,
    getCheckProductTikTok,
    deleteProductTikTok,
    editProductTikTok,
    producttiktok,
    formatterCreateAt,
    getStaffs,
    FormatterStatus,
    deleteProductTikTok2,
    productScheduleMulti,
    createProductById,
    changeStatusProductTikTok,
    findMinQuantity,
    getShops,
    shop,
    syncProductTikTokById,
    syncListPrice,
    user,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [products_selected, setProductsSelected] = useState([]);
    const [filter, setFilter] = useState({});
    const [staffs, setStaffs] = useState([]);
    const [sort_by, setSortBy] = useState("");
    const [sort_order, setSortOrder] = useState("");
    const [shops, setShops] = useState([]);
    const [listing_quality_tier, setlisting_quality_tier] = useState([]);
    const [loadingSync, setLoadingSync] = useState(true);
    const [hiddenPanel, setHiddenPanel] = useState(true);
    const [dataExport, setDataExport] = useState([]);
    const [editListPrice, setEditListPrice] = useState(false);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const btnRef = useRef(null);
    const [productScheduleSelect, setProductScheduleSelect] = useState(null);
    const [productEditPrice, setProductEditPrice] = useState(null);
    const [productEditQty, setProductEditQty] = useState(null);
    const [productEdit, setProductEdit] = useState(null);
    const [productAnalytic, setProductAnalytic] = useState(null);

    const { t } = useTranslation();
    const { list, totalsize, isLoading } = producttiktok;

    const { list: list_shop } = shop;
    const { _id, email } = user.user;

    const listshop = list_shop?.map((v, i) => {
        return { label: `${v?.name} (${v?.note}) - ${v?.region}`, value: v?._id };
    });

    const listQualityTier = [
        { value: "", label: "ALL" },
        { value: "GOOD", label: "GOOD" },
        { value: "FAIR", label: "FAIR" },
        { value: "POOR", label: "POOR" },
    ];

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "20",
            value: 20,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "300",
            value: 300,
        },
        {
            text: "All",
            value: totalsize || 50,
        },
    ];

    const onChangeShop = (e) => {
        var shops_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            shops: shops_tmp || [],
        }));
        setShops(shops_tmp);
    };

    const onChangeTier = (e) => {
        var tier_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            listing_quality_tier: tier_tmp || [],
        }));
        setlisting_quality_tier(tier_tmp);
    };

    useEffect(() => {
        getShops({ page: 1, sizeperpage: 1000 });
    }, [getShops]);

    useEffect(() => {
        if (Object.keys(filter).length) {
            getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter, sort_by, sort_order });
        }
    }, [getProductTikToks, page, sizePerPage, searchText, filter, sort_by, sort_order]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        getStaffs({ sizeperpage: 100 }).then((data) => {
            var options = [
                { value: _id, label: email },
                ...data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email }))
            ]
            setStaffs(options);
        });
    }, [getStaffs]);

    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    const columns = [
        {
            field: "checkbox",
            headerName: "",
            cellClass: "centered-cell",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 50,
            sortable: false,
        },
        // {
        //     field: "_id",
        //     headerName: "No",
        //     editable: false,
        //     cellClass: "centered-cell",
        //     width: 50,
        //     cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
        //     comparator: () => 0,
        // },
        {
            field: "main_images",
            headerName: "Main Images",
            cellClass: "centered-cell overflow-visible",
            sortable: false,
            editable: false,
            width: 120,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <>
                    <div className="symbol symbol-50px">
                        <ReactImageMagnify
                            {...{
                                smallImage: {
                                    alt: "",
                                    width: 50,
                                    height: 50,
                                    src: cell?.[0] || require("components/assets/media/misc/image.png"),
                                },
                                largeImage: {
                                    src: cell?.[0] || require("components/assets/media/misc/image.png"),
                                    width: 600,
                                    height: 600,
                                },
                                enlargedImageContainerDimensions: { width: "600%", height: "600%" },
                                enlargedImageContainerStyle: { zIndex: 99 },
                                className: "cursor-pointer",
                                enlargedImageContainerClassName: "al-zoom-img-cus",
                            }}
                        />
                    </div>
                </>
            ),
        },
        {
            field: "title",
            headerName: t("Title"),
            width: 550,
            sortable: false,
            headerStyle: { width: "650px" },
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <>
                    <div className="d-flex flex-stack">
                        <Link
                            to={"https://shop.tiktok.com/view/product/" + row.apiProductId}
                            className="d-flex flex-stack"
                            target="_blank"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={cell}
                        >
                            <span className="text-primary fw-semibold fs-6 me-2">{cell}</span>{" "}
                            <i className="ki-outline ki-exit-right-corner fs-2"></i>
                        </Link>
                    </div>
                    <div className="d-flex flex-stack mb-2">
                        {findMinQuantity(row?.skus) === 0 ? (
                            <FormatterStatus status={"Out Of Stock"} />
                        ) : findMinQuantity(row?.skus) < 5 ? (
                            <FormatterStatus status={"Low Stock"} />
                        ) : (
                            <FormatterStatus status={"In Stock"} />
                        )} <span className="text-muted fs-7">{row?.apiProductId}<i className="ki-outline ki-copy ms-3" data-tooltip-id="my-tooltip"
                            data-tooltip-content={"Copy"} onClick={() => navigator.clipboard.writeText(row.apiProductId)}></i></span>
                    </div>
                </>
            ),
        },
        // {
        //     field: "apiStatus",
        //     headerName: t("Status"),
        //     sortable: false,
        //     cellRenderer: ({ rowIndex, value: cell, data: row }) => <FormatterStatus status={cell} />,
        // },
        {
            field: "product_sku",
            headerName: t("SKU"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <Fragment>
                    <div className="text-muted fs-7" >{row?.skus?.[0]?.seller_sku || cell || "-"}<i className="ki-outline ki-copy ms-3" data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Copy"} onClick={() => navigator.clipboard.writeText(row?.skus?.[0]?.seller_sku || cell || "")}></i></div>
                </Fragment>
            ),
        },
        {
            field: "listing_quality_tier",
            headerName: t("Tier"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <>
                    {cell === "GOOD" ? (
                        <>
                            Good
                            <div className="d-flex align-items-end">
                                <div className="bullet w-15px h-8px rounded-2 bg-success me-3"></div>
                                <div className="bullet w-15px h-8px rounded-2 bg-success me-3"></div>
                                <div className="bullet w-15px h-8px rounded-2 bg-success me-3"></div>
                            </div>
                        </>
                    ) : cell === "FAIR" ? (
                        <>
                            Fair
                            <div className="d-flex align-items-end">
                                <div className="bullet w-15px h-8px rounded-2 bg-warning me-3"></div>
                                <div className="bullet w-15px h-8px rounded-2 bg-warning me-3"></div>
                            </div>
                        </>
                    ) : cell === "POOR" ? (
                        <>
                            Poor
                            <div className="d-flex align-items-end">
                                <div className="bullet w-15px h-8px rounded-2 bg-danger me-3"></div>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                </>
            ),
        },
        // {
        //     field: "shopId",
        //     headerName: t("Shop ID"),
        //     sort: true,
        //     headerClasses: "d-none",
        //     classes: "d-none",
        //     cellRenderer: ({ rowIndex, value: cell, data: row }) => `${cell?.name} (${cell?.region})`,
        // },
        {
            field: "orders_count",
            headerName: t("Performance"),
            sort: true,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <div>
                {`${cell || 0}`} items sold
                <div className="text-muted fs-6">Views: -</div>
            </div>,
            sortable: true,
            comparator: () => 0,
        },
        {
            field: "created_at",
            headerName: t("Created At"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <div>
                {formatterCreateAt(cell)}
                <div className="text-muted fs-7"><FormatterStatus status={row?.apiStatus} /></div>
            </div>,
        },
        {
            field: "createdBy",
            headerName: t("Created By"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => row?.createdBy?.email,
        },
        {
            field: "shops",
            headerName: t("Shop"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => `${cell?.name} (${cell?.note}) - ${cell?.region}`,
        },
        {
            field: "-",
            headerName: t("Actions"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <>
                    <span
                        role="button"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Edit")}
                        onClick={() => setProductEdit(row)}
                    >
                        <i className="ki-outline ki-notepad-edit fs-2"></i>
                    </span>
                    <Link
                        role="button"
                        to="#"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Edit Price")}
                        onClick={() => setProductEditPrice(row)}
                    >
                        <i className="ki-outline ki-wallet fs-2"></i>
                    </Link>
                    <Link
                        role="button"
                        to="#"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Edit Quantity")}
                        onClick={() => setProductEditQty(row)}
                    >
                        <i className="ki-outline ki-abstract-26 fs-2"></i>
                    </Link>
                    <span
                        role="button"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Sync Product")}
                        onClick={async () => {
                            await syncProductTikTokById(row._id);
                            getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                        }}
                    >
                        <i className="bi bi-arrow-repeat fs-2"></i>
                    </span>

                    <button
                        className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Analytic"
                        onClick={() => setProductAnalytic(row.apiProductId)}
                    >
                        <i className="ki-outline ki-outline ki-ranking fs-2"></i>
                    </button>
                    {/* <button
                        className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Delete")}
                        onClick={() =>
                            getCheckProductTikTok([row._id]).then((data) => {
                                if (data) getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter, sort_by, sort_order });
                            })
                        }
                    >
                        <i className="ki-outline ki-trash fs-2"></i>
                    </button> */}
                    {/* <button onClick={() => {
                        setProductScheduleSelect({
                            ...row,
                            page, sizeperpage: sizePerPage, search: searchText, filter
                        })
                    }} className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Schedule")}>
                        <i className="ki-outline ki-calendar-add fs-2"></i>
                    </button> */}
                </>
            ),
        },
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const handleFilter = (e) => {
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };
    const onClickDeleteProduct = () => {
        setLoadingSync(true);
        getCheckProductTikTok(products_selected).then((data) => {
            const groupShop = _.groupBy(data?.filterProduct, "shopId");
            const mapDelete = Object.entries(groupShop);
            Promise.all(
                mapDelete.map(async (data_shop, i) => {
                    await sleep(i * 500);
                    return new Promise(async (resolve2, reject2) => {
                        const key_shop = data_shop?.[0];
                        const key_data = data_shop?.[1];
                        await deleteProductTikTok({ key_shop, key_data }).then(async (a) => {
                            resolve2("ok");
                        });
                    });
                })
            ).then(async (dat) => {
                if (data)
                    getProductTikToks({
                        page,
                        sizeperpage: sizePerPage,
                        search: searchText,
                        filter,
                        sort_by,
                        sort_order,
                    });
                Swal.fire(t("Success"), t("Deleted success"), "success");
                setLoadingSync(false);
            });
        });
    };

    const onClickChangeStatusProduct = () => {
        setLoadingSync(true);
        getCheckProductTikTok(products_selected).then((data) => {
            const groupApp = _.groupBy(data?.filterProduct, "appId");
            const mapSyncPrice = Object.values(groupApp);
            Promise.all(
                mapSyncPrice.map(async (data_app, i) => {
                    await sleep(i * 500);
                    return new Promise(async (resolve2, reject2) => {
                        const groupShop = _.groupBy(data_app, "shopId");
                        const mapShop = Object.entries(groupShop);
                        for (var i = 0; i < mapShop.length; i++) {
                            var data_shop = mapShop[i];
                            const key_shop = data_shop?.[0];
                            const key_data = data_shop?.[1];
                            await changeStatusProductTikTok({ key_shop, key_data }).then(async (a) => {
                                resolve2("ok");
                            });
                        }
                    });
                })
            ).then(async (dat) => {
                if (data)
                    getProductTikToks({
                        page,
                        sizeperpage: sizePerPage,
                        search: searchText,
                        filter,
                        sort_by,
                        sort_order,
                    });
                Swal.fire(t("Success"), t("Deleted success"), "success");
                setLoadingSync(false);
            });
        });
    };

    const onClickSyncListPrice = async (amount, dataListPrice) => {
        await getCheckProductTikTok(products_selected).then(async (data) => {
            const groupApp = _.groupBy(data?.filterProduct, "appId");
            const mapSyncPrice = Object.values(groupApp);
            var totalSuccess = 0;
            var totalFail = 0;
            setLoadingSync(true);
            await Promise.all(
                mapSyncPrice.map(async (data_app, i) => {
                    await sleep(i * 500);
                    return new Promise(async (resolve2, reject2) => {
                        for (var i = 0; i < data_app.length; i++) {
                            var data_sync = data_app[i];
                            data_sync.skus = data_sync.skus.map((sku) => {
                                let list_price;
                                if (dataListPrice.type === "plus" && +dataListPrice.extValue) {
                                    list_price = {
                                        amount: (+dataListPrice?.extValue + +sku?.price).toString(),
                                        currency: "USD",
                                    };
                                }

                                if (dataListPrice?.type === "percent" && dataListPrice?.extValue) {
                                    list_price = {
                                        amount: (+sku?.price + (+sku?.price * +dataListPrice?.extValue) / 100).toFixed(
                                            2
                                        ),
                                        currency: "USD",
                                    };
                                }

                                if (dataListPrice?.type === "fixed" && +dataListPrice?.amount) {
                                    list_price = {
                                        amount: dataListPrice?.amount?.toString(),
                                        currency: "USD",
                                    };
                                }
                                return {
                                    ...sku,
                                    list_price,
                                };
                            });

                            await syncListPrice({ data_sync }).then(async (a) => {
                                if (a === 200) {
                                    totalSuccess++;
                                } else {
                                    totalFail++;
                                }
                                resolve2("ok");
                            });
                        }
                    });
                })
            ).then(async (dat) => {
                setLoadingSync(true);
                if (data)
                    await getProductTikToks({
                        page,
                        sizeperpage: sizePerPage,
                        search: searchText,
                        filter,
                        sort_by,
                        sort_order,
                    });
                Swal.fire(
                    t("Success"),
                    t(`Sync ${totalSuccess} OK - ${totalFail} Can on going Flash Sale!`),
                    "success"
                );
                setLoadingSync(false);
            });
            setLoadingSync(false);
        });
    };

    const onClickEditProduct = (type) => {
        setLoadingSync(true);
        getCheckProductTikTok(products_selected).then((data) => {
            const groupShop = _.groupBy(data?.filterProduct, "shopId");
            const mapDelete = Object.entries(groupShop);
            Promise.all(
                mapDelete.map(async (data_shop, i) => {
                    return new Promise(async (resolve2, reject2) => {
                        const shopId = data_shop?.[0];
                        const key_data = data_shop?.[1];
                        Promise.all(
                            key_data.map(async (productId, i) => {
                                await sleep(i * 500);
                                return new Promise(async (resolve, reject) => {
                                    await editProductTikTok({
                                        productId,
                                        shopId,
                                        type,
                                    }).then(async (a) => {
                                        resolve("ok");
                                    });
                                });
                            })
                        ).then(async (dat) => {
                            resolve2("ok");
                        });
                    });
                })
            ).then(async (dat) => {
                if (data)
                    getProductTikToks({
                        page,
                        sizeperpage: sizePerPage,
                        search: searchText,
                        filter,
                        sort_by,
                        sort_order,
                    });
                Swal.fire(t("Success"), t("Edited success"), "success");
                setLoadingSync(false);
            });
        });
    };

    const handleDeleteProduct = async (data) => {
        setLoadingSync(true);
        await deleteProductTikTok2({ data }).then((data_) => {
            setLoadingSync(false);
            return Swal.fire(t("Success"), t("Delete Success!"), "success");
        });
    };

    const handleSchedule = async (data) => {
        var products = list
            ?.filter((v, i) => products_selected.includes(v._id.toString()))
            ?.map((v, i) => {
                var product = {
                    _id: v?._id?.toString(),
                    title: v?.title,
                    main_images: v?.main_images || "",
                };
                return product;
            });
        await productScheduleMulti({ ...data, products, type: "tiktok" }, setLoadingSync);
        setLoadingSync(false);
    };

    const onClickExportData = async () => {
        setLoadingSync(true);
        let save_data_export = [];
        save_data_export = list
            ?.filter((v, i) => products_selected?.includes(v._id))
            ?.map((v, i) => {
                return {
                    title: v.title,
                    productId: v.apiProductId,
                    sku: v?.skus?.[0]?.seller_sku || v.product_sku || "",
                    image1: v?.main_images?.[0] || "",
                    image2: v?.main_images?.[1] || "",
                    image3: v?.main_images?.[2] || "",
                    image4: v?.main_images?.[3] || "",
                    image5: v?.main_images?.[4] || "",
                    image6: v?.main_images?.[5] || "",
                    image7: v?.main_images?.[6] || "",
                    image8: v?.main_images?.[7] || "",
                    image9: v?.main_images?.[8] || "",
                };
            });
        setDataExport(save_data_export);
        setInitiateDownload(true);
        await sleep(2500);
        setLoadingSync(false);
    };

    const onClickCreateProductById = () => {
        setLoadingSync(true);
        createProductById(products_selected).then((data) => {
            setLoadingSync(false);
            if (data) getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
        });
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelectionChanged = (data) => {
        if (data.api) {
            const ids = data.api.getSelectedRows().map((d) => d._id);
            setProductsSelected(ids);
            if (ids.length !== 0) {
                setLoadingSync(false);
            }
            if (ids.length === 0) {
                setLoadingSync(true);
            }
        }
    };

    const onSelect = (row, isSelect) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp.push(row._id);
        } else {
            products_selected_tmp = removeSelect(products_selected_tmp, row._id);
        }
        var new_arr = JSON.stringify(products_selected_tmp);
        setProductsSelected(JSON.parse(new_arr));
        if (products_selected_tmp.length !== 0) {
            setLoadingSync(false);
        }
        if (products_selected_tmp.length === 0) {
            setLoadingSync(true);
        }
    };

    const onSelectAll = (isSelect, row) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp = row.map((v, i) => v._id);
        } else {
            products_selected_tmp = [];
        }
        setProductsSelected(products_selected_tmp);
        if (products_selected_tmp.length !== 0) {
            setLoadingSync(false);
        }
        if (products_selected_tmp.length === 0) {
            setLoadingSync(true);
        }
    };

    const groupButton = () => {
        return (
            <div>
                <div className="mb-5 d-flex flex-md-row flex-column gap-2">
                    <button
                        onClick={() => {
                            onClickDeleteProduct();
                        }}
                        disabled={loadingSync}
                        type="button"
                        className="btn btn-danger btn-sm"
                    >
                        <i className="ki-outline ki-cross-circle fs-2"></i> {t("Delete Product")}
                    </button>
                    <ModalDeleteProductTikTok
                        onSubmit={(data) => {
                            handleDeleteProduct(data);
                        }}
                    />
                    <button
                        disabled={loadingSync}
                        onClick={() => {
                            onClickEditProduct("CoTik.App");
                        }}
                        type="button"
                        className="btn btn-info btn-sm"
                        hidden={true}
                    >
                        <i className="ki-outline ki-shield-tick fs-2"></i> {t("As Draft To Listing")}
                    </button>
                    <button
                        onClick={() => {
                            onClickChangeStatusProduct();
                        }}
                        disabled={loadingSync}
                        type="button"
                        className="btn btn-warning btn-sm"
                    >
                        <i className="ki-outline ki-switch fs-2"></i> {t("Change Status")}
                    </button>
                    <ModalScheduleMulti
                        onSubmit={handleSchedule}
                        shops={listshop}
                        products_selected={products_selected?.length}
                    />
                    <button
                        onClick={() => {
                            onClickCreateProductById();
                        }}
                        type="button"
                        className="btn btn-primary btn-sm"
                    >
                        <i className="bi bi-arrow-repeat fs-2"></i> {t("Create Product System")}
                    </button>
                    <button
                        disabled={loadingSync}
                        onClick={() => {
                            setHiddenPanel(!hiddenPanel);
                        }}
                        type="button"
                        className="btn btn-primary btn-sm"
                    >
                        <i className="ki-outline ki-arrows-circle fs-2"></i> {t("Edit All")}
                    </button>
                    <button
                        onClick={() => setEditListPrice(true)}
                        disabled={loadingSync}
                        type="button"
                        className="btn btn-warning btn-sm"
                    >
                        <i className="bi bi-arrow-repeat fs-2"></i> {t("Sync List Price")}
                    </button>
                    <button onClick={onClickExportData} className="btn btn-sm btn-success mr-1">
                        <i className="ki-outline ki-exit-down"></i>Export
                    </button>
                    <CSVLink filename={"data_tiktok_" + dataExport.length + "_products.csv"} data={dataExport}>
                        <span ref={btnRef} />
                    </CSVLink>
                </div>
                <div className="mb-5 d-flex flex-md-row flex-column justify-content-start w-100 gap-3">
                    <Select
                        isClearable
                        isMulti
                        name="shop"
                        options={listshop}
                        className="cotik-select-virtual"
                        classNamePrefix="select"
                        value={listshop.filter(({ value }) => shops.includes(value))}
                        onChange={(e) => {
                            onChangeShop(e);
                        }}
                        placeholder={t("Select a shop ... ")}
                        theme={(theme) => ({
                            ...theme,
                            spacing: {
                                ...theme.spacing,
                                controlHeight: "100%",
                                controlWidth: "200px",
                            },
                        })}
                    />
                    <select
                        className="form-select basic-multi-select al-custom-select-search-variants al-filter-table"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="currency"
                        name="status"
                        onChange={handleFilter}
                    >
                        <option value="ACTIVATE">ACTIVATE</option>
                        <option value="DRAFT">DRAFT</option>
                        <option value="PENDING">PENDING</option>
                        <option value="FAILED">FAILED</option>
                        <option value="SELLER_DEACTIVATED">SELLER_DEACTIVATED</option>
                        <option value="PLATFORM_DEACTIVATED">PLATFORM_DEACTIVATED</option>
                        <option value="FREEZE">FREEZE</option>
                        <option value="DELETED">DELETED</option>
                        <option value="">ALL</option>
                    </select>
                    <Select
                        isClearable
                        isMulti
                        name="listing_quality_tier"
                        options={listQualityTier}
                        className="cotik-select-virtual"
                        classNamePrefix="select"
                        value={listQualityTier.filter(({ value }) => listing_quality_tier.includes(value))}
                        onChange={(e) => {
                            onChangeTier(e);
                        }}
                        placeholder={t("Select a tier ... ")}
                        theme={(theme) => ({
                            ...theme,
                            spacing: {
                                ...theme.spacing,
                                controlHeight: "100%",
                                controlWidth: "200px",
                            },
                        })}
                    />
                    <SelectBox
                        className="me-2"
                        options={staffs}
                        name="filter_staff"
                        placeholder="Select Staff"
                        value={filter.staff || ""}
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                staff: data.value || "",
                            }));
                            setPage(1);
                        }}
                    />
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="al-select"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
                <span className="h3">Total: {totalsize} Products</span>
            </div>
        );
    };

    const onTableChanged = ({ page, limit, text }) => {
        if (limit) setSizePerPage(limit);
        if (page) setPage(page);
        if (typeof text === "string") setSearchText(text);
    };

    const defaultColDef = useMemo(
        () => ({
            wrapText: true,
            autoHeight: true,
            wrapHeaderText: true,
            autoHeaderHeight: true,
        }),
        []
    );

    const components = useMemo(() => {
        return {
            agColumnHeader: CustomHeader,
        };
    }, []);

    const onSortChanged = (e) => {
        if (e.source === "uiColumnSorted") {
            console.log(e.api.setSuppressAnimations);
            const sortedColumns = e.api.getColumnState().filter((col) => col.sort);
            console.log(sortedColumns?.[0]?.colId, sortedColumns?.[0]?.sort);

            setSortBy(sortedColumns?.[0]?.colId);
            setSortOrder(sortedColumns?.[0]?.sort || "desc");
        }
    };

    return (
        <>
            <div className="card min-w-full">
                <Loading isLoading={isLoading} />
                <div className="card-body">
                    <div className="al-variants-table al-max-height-table-cus">
                        {/* <ReactTable
                            columns={columns}
                            data={list || []}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit"
                            sizePerPageList={sizePerPageList}
                            isSelectRow={true}
                            selectRow={selectRow}
                        /> */}

                        <ReactTableDataGrid
                            tableName="productsTiktokTable"
                            idProperty="_id"
                            columns={columns}
                            rowData={list}
                            defaultColDef={defaultColDef}
                            gridOptions={{
                                reactiveCustomComponents: true,
                            }}
                            paginationPageSize={sizePerPage}
                            totalSize={totalSize}
                            onTableChanged={onTableChanged}
                            emptyText={t("No data!")}
                            rowSelection="multiple"
                            onSelectionChanged={onSelectionChanged}
                            sizePerPageList={sizePerPageList}
                            groupButton={groupButton}
                            onSortChanged={onSortChanged}
                            components={components}
                        />
                    </div>
                </div>
            </div>
            <div className="card min-w-full mt-5" hidden={hiddenPanel}>
                <div className="card-body">
                    <h3>Edit Multiple Product</h3>
                    <EditProductTikTok products_selected={products_selected} />
                </div>
            </div>
            <ModalSchedule
                data={productScheduleSelect}
                shops={listshop}
                onClose={() => setProductScheduleSelect(null)}
                onSubmit={() => {
                    getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalEditPrice
                isOpen={Boolean(productEditPrice)}
                onClose={() => setProductEditPrice(null)}
                product={productEditPrice}
                onSubmit={() => {
                    getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalEditQty
                isOpen={Boolean(productEditQty)}
                onClose={() => setProductEditQty(null)}
                product={productEditQty}
                onSubmit={() => {
                    getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalEditProductV2
                isOpen={Boolean(productEdit)}
                onClose={() => setProductEdit(null)}
                product={productEdit}
                onSubmit={() => {
                    getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalAnalytic productId={productAnalytic} onClose={() => setProductAnalytic(null)} />
            <ModalListPrice
                isOpen={Boolean(editListPrice)}
                onClose={() => setEditListPrice(false)}
                onSubmit={onClickSyncListPrice}
            />
        </>
    );
};

const mapStateToProps = ({ producttiktok, shop, user }) => ({ producttiktok, shop, user });
const mapDispatchToProps = {
    getProductTikToks,
    getCheckProductTikTok,
    deleteProductTikTok,
    formatterCreateAt,
    getStaffs,
    findMinQuantity,
    FormatterStatus,
    editProductTikTok,
    deleteProductTikTok2,
    productScheduleMulti,
    createProductById,
    changeStatusProductTikTok,
    getShops,
    syncProductTikTokById,
    syncListPrice,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
